<script lang="ts">
  import { SelectOption } from './form/SelectWithLabel.svelte';

  export let id: string;
  export let placeholder: string | undefined = undefined;
  export let options: SelectOption[] | [] = [];
  export let selectedOption: string  | undefined;
</script>

<select class="select" {id} bind:value={selectedOption} on:change>
  {#if options.length > 0}
    {#if placeholder}
    <option value='' disabled selected={!selectedOption}>{placeholder}</option>
    {/if}
    {#each options as { label, value }}
      <option value={value}>
        {label}
      </option>
    {/each}
  {:else}
    <option value="" disabled selected>
      Keine Optionen verfügbar
    </option>
  {/if}
</select>

<style lang="scss">
  @use '../styles/colors';
  @use '../styles/spacing';

  .select {
    border: spacing.$xxxs solid transparent;
    border-radius: spacing.$xxs;
    background-color: colors.$white100;
    border-color: colors.$black40;
    cursor: pointer;
    appearance: auto;
    padding: spacing.$xs spacing.$xs;

    &:hover,
    &:focus {
      border-color: colors.$black90;
    }
  }
  option:disabled {
    cursor: not-allowed;
    color: colors.$black40;
    border-color: transparent;
  }
</style>
